import Header from 'components/common/Header';
import ServiceDashboard from 'components/service/ServiceDashboard';
import useCheckAuth from 'hooks/common/useCheckAuth';
import styled, { css } from 'styled-components';

const ServiceDashboardPage = () => {
  const isCheck = useCheckAuth('1');

  return (
    <ServiceDashboardPageBlock isCheck={isCheck}>
      <Header service />
      <ServiceDashboard />
    </ServiceDashboardPageBlock>
  );
};

export default ServiceDashboardPage;

const ServiceDashboardPageBlock = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  ${props =>
    !props.isCheck &&
    css`
      visibility: hidden;
    `}
`;
